import actionTypes from '../actionTypes';

export const getInvites = (dealId) => ({
  type: actionTypes.INVITES_GET_REQUEST,
  dealId,
});

export const getUserInvites = (userId) => ({
  type: actionTypes.INVITES_USER_GET_REQUEST,
  userId,
});

export const getInvite = (dealId, inviteId) => ({
  type: actionTypes.INVITE_GET_REQUEST,
  dealId,
  inviteId,
});

export const selectInvite = (dealId, invite) => ({
  type: actionTypes.INVITE_SELECT,
  dealId,
  invite,
});

export const createInvite = (dealId, invite) => ({
  type: actionTypes.INVITE_CREATE_REQUEST,
  dealId,
  invite,
});

export const updateInvite = (invite) => ({
  type: actionTypes.INVITE_UPDATE_REQUEST,
  invite,
});

export const deleteInvite = (dealId, inviteId) => ({
  type: actionTypes.INVITE_DELETE_REQUEST,
  dealId,
  inviteId,
});

export const getInviteByKey = (key) => ({
  type: actionTypes.INVITE_GET_BY_KEY_REQUEST,
  key,
});

export const resendDealInvitation = (dealId, inviteId) => ({
  type: actionTypes.RESEND_DEAL_INVITATION_REQUEST,
  dealId,
  inviteId,
});



// WEBPACK FOOTER //
// src/redux/actions/invites.js